import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
// TODO: Import required services for Foreign Keys
import { StageService } from '../proxy/controlling/controllers/stage.service';
import { ProcessService } from '../proxy/controlling/controllers/process.service';

FieldBuilder.setNamespace('Controlling');

export const STAGEPERPROCESS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('stageId', 'Entity.Stage', StageService)
    .required()
    .displayFromNested('stage.name')
    .sortBy('stage.name')
    .build(),
  FieldBuilder
    .foreignKey('processId', 'Entity.Process', ProcessService)
    .required()
    .displayFromNested('process.name')
    .sortBy('process.name')
    .build(),
];

export const STAGEPERPROCESS_CONFIG = {
  entityName: 'StagePerProcess',
  localizationKey: 'Controlling::Entity.StagePerProcess',
  fields: STAGEPERPROCESS_FIELDS,
  permission: 'ControllingActivities.StagePerProcesses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
